import '@archetype-themes/scripts/vendors/flickity';
import '@archetype-themes/scripts/vendors/flickity-fade';
import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/init-observer';
import '@archetype-themes/scripts/helpers/utils';

class VideoCarouselSection extends HTMLElement {
    constructor() {
        super();    
        this.carousel = this.querySelector('.video-carousel');
        this.items = this.querySelectorAll('.carousel-item');
        this.playType = this.dataset.play;
        this.mute = this.dataset.mute;
        this.videos = this.querySelectorAll('.item-video .video');
        this.init();
    }

    init() {

        let sliderArgs = {
            contain: true,
            pageDots: false,
            setGallerySize: true,
            wrapAround: true,
            draggable: false,
            imagesLoaded: true
        }

        if(this.items.length < 3) {
            sliderArgs.wrapAround = false;
        }
        this.flickity =  new Flickity(this.carousel, sliderArgs);

        this.videosMuteHandler();
        this.togglePlayVideos();
        // this.currentVideo = this.flickity.selectedElement.querySelector('.video');
        // this.currentVideo.play();

        this.muteButtons = this.querySelectorAll('.mute-button');
        Array.from(this.muteButtons).forEach(function(btn){
            btn.addEventListener('click', this.videosMuteHandler.bind(this));
        }, this);
    
        this.flickity.reposition();
        this.setHeightViewport();
        this.flickity.on('change', this.onChangeSlide.bind(this));

        document.addEventListener('resize', this.setHeightViewport());
        
        this.isPlayFirstVideo = false;
        window.addEventListener('scroll', this.autoPlayFirstSelectedVideo.bind(this));
        
    }
    togglePlayVideos() {
        Array.from(this.videos).forEach(function(video){
            video.addEventListener('click', function(){
                if(video.paused) {
                    video.play();
                }else {
                    video.pause();
                }
            })
        }, this);
    }
    setHeightViewport() {
        let largeHeight = this.flickity.selectedElement.offsetHeight;
        
        let viewport = this.flickity.element.querySelector('.flickity-viewport');
        viewport.style.height = largeHeight + 'px';
    }
    autoPlayFirstSelectedVideo() {
        let offset = this.offsetTop - window.scrollY;
        if(!this.isPlayFirstVideo && offset < (window.innerHeight/2)) {
            
            this.flickity.selectedElement.querySelector('.video').play();
            this.isPlayFirstVideo = true;
        }
    }
    videosMuteHandler() {
        
        Array.from(this.flickity.cells).forEach(function(slide){
            let video = slide.element.querySelector('.video');
            video.muted = this.mute;
            
            let soundOnIcon =  slide.element.querySelector('.icon-sound--on');
            let soundOffIcon =  slide.element.querySelector('.icon-sound--off');

            if(this.mute) {
                soundOnIcon.classList.add('hide');
                soundOffIcon.classList.remove('hide');
            }else {
                soundOnIcon.classList.remove('hide');
                soundOffIcon.classList.add('hide');
            }
        }, this);

        // change mute value for waiting next action
        this.mute = !this.mute;
    }
    onChangeSlide() {
        let slides = this.flickity.cells;
        this.flickity.reposition();
        this.setHeightViewport();
        Array.from(slides).forEach(function(slide){
            let video = slide.element.querySelector('.video');
            video.pause();

            if(this.playType == 'replay') {
                video.currentTime = 0;
            }
        }, this);

        this.currentVideo = this.flickity.selectedElement.querySelector('.video');
        this.currentVideo.play();
    }
}
customElements.define('video-carousel', VideoCarouselSection);